/*
 * This file contains all constants related to Should Cost Library
 */

export const KPI_Card_Header_Label = {
  model: 'Model',
  country: 'Source Country',
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
}

export const Should_Cost_Library_Filter_Label = {
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
  country: 'Source Country',
}

export const Should_Cost_Library_Initial_State = {
  summaryFiltersData: {
    l1: '',
    l2: '',
    l3: '',
    country: '',
    filtersLoading: false,
  },
  kpi: {
    kpiData: {},
    kpiLoader: false,
  },
}

export const Model_Meta_Data_Initial_State = {
  modelMetaDataLoader: false,
  modelMetaData: {
    modelName: '',
    modelDescription: '',
    manufacturingCountry: '',
    l1: '',
    l2: '',
    l3: '',
    specifications: [],
    attachments: [],
    creationDate: '',
  },
  modelMetaDataError: '',
}

export const Model_Creation_Approach = {
  top_down: 'Top Down',
  bottom_up: 'Bottom Up',
  derived: 'Derived',
}

export const Model_Status = {
  COMPLETED: 'Completed',
  INPROGRESS: 'In progress',
  NEW: 'New',
}

export const Trendline_Chart_Colors = {
  Po_Trendline: '#118DFF',
  Should_Cost_Trendline: '#E66C37',
}

export const Should_Cost_Library_Messages = {
  Confirm_Delete_Should_Cost:
    'This action will delete selected model and its attachments completely. Click confirm if you would wish to proceed!',
  Delete_Model_Error: 'Failed to delete should cost model',
  Get_Model_MetaData_Error: 'Failed to retrieve model meta data',
  Drag_Drop: 'Drag & drop component from left panel to create custom breakdown',
  Select_Sub_Component: 'Select Component to add Child component for that',
  Create_Model_Success: 'Should cost model is created successfully',
  Create_Model_Error: 'Failed to create should cost model',
  Update_Model_Success: 'Should cost model is updated successfully',
  Update_Model_Error: 'Failed to update should cost model',
  Trendline_Error:
    'Unable to generate Should Cost Trend. Please verify if complete breakdown is added and commodities are attached!',
  Import_Breakdown_Warning_Message: 'This action will replace all your previous changes for breakdown. Confirm if you would like to proceed.',
  No_Data_Found_Message:'No models found for selected filters',
}

export const Should_Cost_Model_Actions = {
  Create: 'create',
  Edit: 'edit',
  Copy: 'copy',
}

export const Should_Cost_Component_Title = {
  Should_Cost_Library: 'Should Cost Library',
  View_Should_Cost: 'View Should Cost Models',
  Create_Model: 'Create Should Cost Model',
  Edit_Model: 'Edit Should Cost Model',
  Edit_Model_Button: 'Edit Model',
  Save_Model_Button: 'Save Model',
  Create_Model_Button: 'Create Model',
  Copy_Model_Button: 'Copy this Model',
  Cost_Trend: 'Cost Trend',
  Should_Cost_Trend: 'Should Cost Trend',
  Breakdown_Details: 'Breakdown Details',
  Delete_Should_Cost: 'Delete Should Cost Model',
  Top_Down_Approach: 'Top down approach',
  Bottoms_Up_Approach: 'Bottom up approach',
  Upload_Should_Cost: 'Upload should cost',
  Select_Creation_Approach: 'Create Should Cost Model',
  GenAI_Drawer_Title: 'Generate Breakdown Using Gen AI',
  Import_Model: 'Import Breakdown',
  Search_Product_Label: 'Search Product',
  Manufacturing_Country_Label: 'Manufacturing Country',
  Generate_Breakdown_Label: 'Generate Breakdown',
  Cost_Breakdown_Table_Title: 'Product Cost Breakdown',
  Import_Existing_Drawer_Title: 'Use Existing Model',
  Import_Breakdown_Warning_Title: 'Replace Existing Breakdown'
}

export const Should_Cost_Component_Description = {
  Select_Creation_Approach_Sub_Title: 'Select an Approach to create a Should Cost Model.',
  Top_Down_Description: 'Create Should Cost Using Existing Should Cost Template OR From Gen AI',
  Bottoms_Up_Description: 'Create Should Cost From Scratch OR From Existing Should Cost Template.',
  Upload_Should_Cost_Description:
    'Create Should Cost Using Galorath OR Complex Template by Uploading XL File.',
  GenAI_Drawer_Description:
    'Enter products details below to generate Should cost breakdown using Gen AI.',
  Search_Product_Placeholder: 'Search Products and Categories',
  No_Breakdown_Message: 'No Breakdown To Show',
  Import_Existing_Drawer_Description:
    'Select from models below and import breakdown to create should cost model',
  GEN_AI_Breakdown_Loader_Description: 'Generated Breakdown will appear here',
  Please_Try_Again: 'Something went wrong. Please try again',
}

export const COST_LABELS = ['Raw Material & Scrap', 'Labor', 'Packaging', 'Freight Cost']

export const SUBCOMPONENT_REQUIRED_SECTION_IDS = [1, 3, 5, 7]

export const COST_COMPONENT_ORDER = [
  'Raw Material & Scrap',
  'Conversion',
  'Labor',
  'Packaging',
  'Overhead & Margin',
  'Logistics',
  'Duty & Tariff',
]
